import React from 'react';
import PropTypes from 'prop-types';
import { GraphIcon } from '@primer/octicons-react';
import { IdealCurveEditor } from './IdealCurveEditor';
import { IdealCurvePoint } from '../models/IdealCurvePoint';
import { Curve } from '../models/Curve';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class IdealCurveEditorModal extends React.Component {
  static propTypes = {
    idealLabel: PropTypes.string,
    curveFitUrl: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    elements: PropTypes.arrayOf(PropTypes.object).isRequired,
    extraction_methods: PropTypes.arrayOf(PropTypes.object).isRequired,
    initialPoints: PropTypes.arrayOf(PropTypes.instanceOf(IdealCurvePoint)).isRequired,
    initialCurve: PropTypes.instanceOf(Curve),
    initialDependencyElementId: PropTypes.number,
    initialDependencyElementExtractionMethodId: PropTypes.number,
  };

  static defaultProps = {
    CurveEditorComponent: IdealCurveEditor, // This is just for dependency injection in tests
  };

  constructor(props) {
    super(props);

    const { initialPoints, initialCurve, initialDependencyElementId, initialDependencyElementExtractionMethodId } = this.props;

    this.state = {
      showModal: false,
      editorDirty: false,
      points: initialPoints,
      curve: initialCurve,
      dependencyElementId: initialDependencyElementId,
      dependencyElementExtractionMethodId: initialDependencyElementExtractionMethodId,
    };
  }

  _handleClicked = (event) => {
    event.preventDefault(); // Don't submit the form
    this._showModal();
  };

  _handleCurveChange = (curve, points) => {
    this.setState({
      curve: curve,
      points: points,
    });
  };

  _handleDependencyElementChange = (dependencyElementId) => {
    this.setState({
      dependencyElementId: dependencyElementId,
    });
  };

  _handleDependencyElementExtractionMethodChange = (dependencyElementExtractionMethodId) => {
    this.setState({
      dependencyElementExtractionMethodId: dependencyElementExtractionMethodId,
    });
  };

  _validCurveDefined = () => {
    return (this.state.curve != null) && (this.state.points.length > 0) && (this.state.dependencyElementId != null) && (this.state.dependencyElementExtractionMethodId != null);
  };

  _removeCurve = () => {
    const { onRemove } = this.props;
    onRemove();

    this.setState({
      dependencyElementId: null,
      dependencyElementExtractionMethodId: null,
      curve: null,
      points: [],
    });

    this._hideModal();
  };

  _reset = () => {
    const { initialPoints, initialCurve, initialDependencyElementId, initialDependencyElementExtractionMethodId } = this.props;

    this.setState({
      points: initialPoints,
      curve: initialCurve,
      dependencyElementId: initialDependencyElementId,
      dependencyElementExtractionMethodId: initialDependencyElementExtractionMethodId,
    });
  }

  _showModal = () => {
    this.setState({
      showModal: true,
    });
  };

  _hideModal = () => {
    this.setState({
      showModal: false,
    });
  };

  _accept = () => {
    const { onChange } = this.props;
    onChange(this.state.dependencyElementId, this.state.dependencyElementExtractionMethodId, this.state.curve, this.state.points);
    this._hideModal();
  }

  _cancel = () => {
    this._reset();
    this._hideModal();
  }

  _onEditorDirtyChange = (dirty) => {
    this.setState({
      editorDirty: dirty,
    })
  };

  render() {
    const { elements, extraction_methods, idealLabel, curveFitUrl, CurveEditorComponent } = this.props;

    return (
      <>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip>Define this value to be dependent on another grid value</Tooltip>}
        >
          <a aria-label='Define Curve' href="#" className="btn btn-grid-xs btn-primary" onClick={this._handleClicked}>
            <GraphIcon size="small" />
          </a>
        </OverlayTrigger>

        <Modal
          show={this.state.showModal}
          onHide={this._hideModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Define Dependent Value Curve</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CurveEditorComponent elements={elements} extraction_methods={extraction_methods} yLabel={idealLabel} onCurveChange={this._handleCurveChange} onDependencyElementChange={this._handleDependencyElementChange} onDependencyElementExtractionMethodChange={this._handleDependencyElementExtractionMethodChange} onDirtyChange={this._onEditorDirtyChange} curveFitUrl={curveFitUrl} points={this.state.points} curve={this.state.curve} initialDependencyElementId={this.state.dependencyElementId} initialDependencyElementExtractionMethodId={this.state.dependencyElementExtractionMethodId} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={this._removeCurve} className="mr-auto">
              Remove curve entirely
            </Button>
            <Button variant="secondary" onClick={this._cancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this._accept} disabled={this.state.editorDirty || !this._validCurveDefined()}>Accept</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export { IdealCurveEditorModal };
